import React from 'react';

function DiscountFlag({ article }) {
  const { displayDiscount } = article;

  if (displayDiscount > 0) {
    return (
      <div className="position-relative">
        <div className="discount-flag float-end bg-danger">
          -{displayDiscount}%
        </div>
      </div>
    );
  }
  return null;
}

export default DiscountFlag;
